import { DemoRoot } from './DemoRoot';
import { DemoColumns } from './DemoColumns';
import { DemoCode } from './DemoCode';

export interface PreviewProps {
    controls: React.ReactNode;
    children: React.ReactNode;
    title?: string;
    minHeight?: number;
    code?: string;
}

export default function Preview({ controls, children, title, minHeight, code }: PreviewProps) {
    return (<DemoRoot >
        <DemoColumns
            controls={controls}
            centered
            minHeight={minHeight || 200}
            withPadding
            title={title}
            dimmed
        >
            {children}
        </DemoColumns>
        {code && <DemoCode defaultExpanded={false} code={code} maxCollapsedHeight={140} />}

    </DemoRoot>)
}